import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../styles/DataTable.css";

export interface Props {
  fieldName: string;
  fieldTitle: string;
  currentSortField: string;
  currentSortOrder: string;
  toggleSort: (fieldName: string, sortOrder: string) => void;
}

function Sortcontrol({
  fieldName,
  fieldTitle,
  currentSortField,
  currentSortOrder,
  toggleSort,
}: Props) {
  const handleClick = (e: any) => {
    var newSortOrder = "asc";
    if (currentSortField === fieldName && currentSortOrder === "asc") {
      newSortOrder = "desc";
    }
    toggleSort(fieldName, newSortOrder);
  };
  var icon = <FontAwesomeIcon icon="sort" />;
  if (currentSortField === fieldName) {
    if (currentSortOrder === "asc") {
      icon = <FontAwesomeIcon icon="sort-down" />;
    } else {
      icon = <FontAwesomeIcon icon="sort-up" />;
    }
  }
  return (
    <button
      onClick={handleClick}
      className="ds-c-button ds-c-button--small ds-c-button--transparent ds-u-color--base-inverse data-table-sort-icon"
      title={`Sort by ${  fieldTitle}`}
    >
      {icon}
    </button>
  );
}

export default Sortcontrol;
